import React from 'react';
import styles from './style.css';
import { formatAmountForDisplay } from '../../flows/shared/utils';

const ReviewTrustAllocation = ({ totalAmount, selectedFunds }) => {
  const trustFunds = selectedFunds.filter(fund => fund.balanceAsOf !== '0');

  return (
    <>
      <div className="container">
        <table>
          <tr>
            <th>Account</th>
            <th>Est. Assets to Invest</th>
          </tr>
          {trustFunds.map(fund => (
            <tr key={`${fund.agreementID}`}>
              <td>
                {fund.shortName} ({fund.ticker})
              </td>
              <td>{formatAmountForDisplay(fund.balanceAsOf)}</td>
            </tr>
          ))}
          <tr>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td />
            <td>
              <b>Total to Invest:</b> {formatAmountForDisplay(totalAmount)}
            </td>
          </tr>
        </table>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ReviewTrustAllocation;
